import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef
} from '@angular/core';

import { Menu, MenuItem } from '../detail-action-button/detail-action-buttons.types';

import { MeetingItem } from '~/repositories/meeting/store/meeting.models';

@Component({
  selector: 'app-collapsible-menu',
  templateUrl: './collapsible-menu.component.html',
  styleUrl: './collapsible-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CollapsibleMenuComponent {
  @Input() title: string;
  @Input() toggleable: boolean;
  @Input() collapsed: boolean;
  @Input() loading: boolean;
  @Input() config: Menu;
  @Input() itemClass: string = '';
  @Input() checkedItems: MeetingItem[];

  @Output() collapsedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() itemClick: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

  @ContentChild('content') content: TemplateRef<Element>;

  handleClick(item: MenuItem) {
    this.itemClick.emit(item);
  }
}
